<template>
  <div class="kpArticle_list">
    <div class="kpArticle_listCenter">
      <div class="kpArticle_nav">
        <div ref="kpArticle_nav" :class="flagScroll?'active':''" class="kpArticle_nav_center">
          <div @click="handleGoChild" class="nav_item">
            <img class="one" src="../../assets/images/kpArticle/111.png" alt="">
            <img class="two" src="../../assets/images/home/u1776.png" alt="">
            <div>内科</div>
          </div>
          <div class="nav_item">
            <img class="one" src="../../assets/images/kpArticle/111.png" alt="">
            <img class="two" src="../../assets/images/home/u1776.png" alt="">
            <div>外科</div>
          </div>
          <div class="nav_item">
            <img class="one" src="../../assets/images/kpArticle/111.png" alt="">
            <img class="two" src="../../assets/images/home/u1776.png" alt="">
            <div>妇产科</div>
          </div>
          <div class="nav_item">
            <img class="one" src="../../assets/images/kpArticle/111.png" alt="">
            <img class="two" src="../../assets/images/home/u1776.png" alt="">
            <div>儿科</div>
          </div>
          <div class="nav_item">
            <img class="one" src="../../assets/images/kpArticle/111.png" alt="">
            <img class="two" src="../../assets/images/home/u1776.png" alt="">
            <div>男性科</div>
          </div>
          <div class="nav_item">
            <img class="one" src="../../assets/images/kpArticle/111.png" alt="">
            <img class="two" src="../../assets/images/home/u1776.png" alt="">
            <div>耳鼻喉科</div>
          </div>
          <div class="nav_item">
            <img class="one" src="../../assets/images/kpArticle/111.png" alt="">
            <img class="two" src="../../assets/images/home/u1776.png" alt="">
            <div>口腔科</div>
          </div>
          <div class="nav_item">
            <img class="one" src="../../assets/images/kpArticle/111.png" alt="">
            <img class="two" src="../../assets/images/home/u1776.png" alt="">
            <div>不孕不育科</div>
          </div>
          <div class="nav_item">
            <img class="one" src="../../assets/images/kpArticle/111.png" alt="">
            <img class="two" src="../../assets/images/home/u1776.png" alt="">
            <div>肿瘤科</div>
          </div>
          <div class="nav_item">
            <img class="one" src="../../assets/images/kpArticle/111.png" alt="">
            <img class="two" src="../../assets/images/home/u1776.png" alt="">
            <div>性病科</div>
          </div>
          <div class="nav_item">
            <img class="one" src="../../assets/images/kpArticle/111.png" alt="">
            <img class="two" src="../../assets/images/home/u1776.png" alt="">
            <div>皮肤科</div>
          </div>
          <div class="nav_item">
            <img class="one" src="../../assets/images/kpArticle/111.png" alt="">
            <img class="two" src="../../assets/images/home/u1776.png" alt="">
            <div>康复科</div>
          </div>
          <div class="nav_item">
            <img class="one" src="../../assets/images/kpArticle/111.png" alt="">
            <img class="two" src="../../assets/images/home/u1776.png" alt="">
            <div>中医科</div>
          </div>
          <div class="nav_item">
            <img class="one" src="../../assets/images/kpArticle/111.png" alt="">
            <img class="two" src="../../assets/images/home/u1776.png" alt="">
            <div>其他</div>
          </div>
        </div>
      </div>
      <div class="kpArticle_router">
        <router-view/>
      </div>
      <div class="kpArticle_hot">
        <div class="hebdomad_box">
          <div class="hebdomad">一周热点</div>
          <div class="disease_card_right">
            <div class="item_list">
              <div class="item_GraphicText_list">
                <div class="GraphicImg">
                  <img src="../../assets/images/home/jibing3.jpeg" alt="">
                </div>
                <div class="textTime">
                  <div>没有心脏病的人也会出现心源性猝死吗，这是为什么呢？没有心脏病的人也会出现心源性猝死吗没有心脏病的人也会出现心源性猝死吗没有心脏病的人也会出现心源性猝死吗没有心脏病的人也会出现心源性猝死吗没有心脏病的人也会出现心源性猝死吗</div>
                  <span>2020-03-12</span>
                </div>
              </div>
            </div>
            <div class="item_list">
              <div class="item_GraphicText_list">
                <div class="GraphicImg">
                  <img src="../../assets/images/home/jibing3.jpeg" alt="">
                </div>
                <div class="textTime">
                  <div>没有心脏病的人也会出现心源性猝死吗，这是为什么呢？没有心脏病的人也会出现心源性猝死吗没有心脏病的人也会出现心源性猝死吗没有心脏病的人也会出现心源性猝死吗没有心脏病的人也会出现心源性猝死吗没有心脏病的人也会出现心源性猝死吗</div>
                  <span>2020-03-12</span>
                </div>
              </div>
            </div>
            <div class="item_list">
              <div class="item_GraphicText_list">
                <div class="GraphicImg">
                  <img src="../../assets/images/home/jibing3.jpeg" alt="">
                </div>
                <div class="textTime">
                  <div>没有心脏病的人也会出现心源性猝死吗，这是为什么呢？没有心脏病的人也会出现心源性猝死吗没有心脏病的人也会出现心源性猝死吗没有心脏病的人也会出现心源性猝死吗没有心脏病的人也会出现心源性猝死吗没有心脏病的人也会出现心源性猝死吗</div>
                  <span>2020-03-12</span>
                </div>
              </div>
            </div>
            <div class="item_list">
              <div class="item_GraphicText_list">
                <div class="GraphicImg">
                  <img src="../../assets/images/home/jibing3.jpeg" alt="">
                </div>
                <div class="textTime">
                  <div>没有心脏病的人也会出现心源性猝死吗，这是为什么呢？没有心脏病的人也会出现心源性猝死吗没有心脏病的人也会出现心源性猝死吗没有心脏病的人也会出现心源性猝死吗没有心脏病的人也会出现心源性猝死吗没有心脏病的人也会出现心源性猝死吗</div>
                  <span>2020-03-12</span>
                </div>
              </div>
            </div>
            <div class="item_list">
              <div class="item_GraphicText_list">
                <div class="GraphicImg">
                  <img src="../../assets/images/home/jibing3.jpeg" alt="">
                </div>
                <div class="textTime">
                  <div>没有心脏病的人也会出现心源性猝死吗，这是为什么呢？没有心脏病的人也会出现心源性猝死吗没有心脏病的人也会出现心源性猝死吗没有心脏病的人也会出现心源性猝死吗没有心脏病的人也会出现心源性猝死吗没有心脏病的人也会出现心源性猝死吗</div>
                  <span>2020-03-12</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="recommend_doctor">
          <div class="recommend">医生推荐</div>
          <div class="recommend_list">
            <div class="item_doctor">
              <div class="doctor_head">
                <img src="../../assets/images/home/ceshi3.jpeg" alt="">
              </div>
              <div class="doctor_name">张三三</div>
            </div>
            <div class="item_doctor">
              <div class="doctor_head">
                <img src="../../assets/images/home/ceshi3.jpeg" alt="">
              </div>
              <div class="doctor_name">张三三</div>
            </div>
            <div class="item_doctor">
              <div class="doctor_head">
                <img src="../../assets/images/home/ceshi3.jpeg" alt="">
              </div>
              <div class="doctor_name">张三三</div>
            </div>
            <div class="item_doctor">
              <div class="doctor_head">
                <img src="../../assets/images/home/ceshi3.jpeg" alt="">
              </div>
              <div class="doctor_name">张三三</div>
            </div>
            <div class="item_doctor">
              <div class="doctor_head">
                <img src="../../assets/images/home/ceshi3.jpeg" alt="">
              </div>
              <div class="doctor_name">张三三</div>
            </div>
            <div class="item_doctor">
              <div class="doctor_head">
                <img src="../../assets/images/home/ceshi3.jpeg" alt="">
              </div>
              <div class="doctor_name">张三三</div>
            </div>
            <div class="item_doctor">
              <div class="doctor_head">
                <img src="../../assets/images/home/ceshi3.jpeg" alt="">
              </div>
              <div class="doctor_name">张三三</div>
            </div>
            <div class="item_doctor">
              <div class="doctor_head">
                <img src="../../assets/images/home/ceshi3.jpeg" alt="">
              </div>
              <div class="doctor_name">张三三</div>
            </div>
            <div class="item_doctor">
              <div class="doctor_head">
                <img src="../../assets/images/home/ceshi3.jpeg" alt="">
              </div>
              <div class="doctor_name">张三三</div>
            </div>
            <div class="item_doctor">
              <div class="doctor_head">
                <img src="../../assets/images/home/ceshi3.jpeg" alt="">
              </div>
              <div class="doctor_name">张三三</div>
            </div>
            <div class="item_doctor">
              <div class="doctor_head">
                <img src="../../assets/images/home/ceshi3.jpeg" alt="">
              </div>
              <div class="doctor_name">张三三</div>
            </div>
            <div class="item_doctor">
              <div class="doctor_head">
                <img src="../../assets/images/home/ceshi3.jpeg" alt="">
              </div>
              <div class="doctor_name">张三三</div>
            </div>
            <div class="item_doctor">
              <div class="doctor_head">
                <img src="../../assets/images/home/ceshi3.jpeg" alt="">
              </div>
              <div class="doctor_name">张三三</div>
            </div>
            <div class="item_doctor">
              <div class="doctor_head">
                <img src="../../assets/images/home/ceshi3.jpeg" alt="">
              </div>
              <div class="doctor_name">张三三</div>
            </div>
            <div class="item_doctor">
              <div class="doctor_head">
                <img src="../../assets/images/home/ceshi3.jpeg" alt="">
              </div>
              <div class="doctor_name">张三三</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "List",
    data(){
      return {
        flagScroll:false,
      }
    },
    methods:{
      // nav 滑动固定定位
      handleScroll(){
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        let offsetTop = this.$refs.kpArticle_nav.offsetTop
        let offsetBottom = document.querySelector('.footer_centre').offsetTop
        if (scrollTop > offsetTop+160) {
          this.flagScroll = true
        } else {
          this.flagScroll = false
        }
        if(scrollTop>offsetBottom-800){
          this.flagScroll = false
        }
      },
      handleGoChild(row) {
        this.$router.push({path:'/kpArticle/listCenter',query:{}})
      },
    },
    mounted() {
      window.addEventListener('scroll', this.handleScroll)
    },
    beforeDestroy() {
      // 解除绑定
      window.removeEventListener('scroll',this.handleScroll,false);
    },
  }
</script>
<style lang="stylus" scoped>
  div{
    box-sizing border-box
  }
  .kpArticle_list{
    margin-top 30px
    position relative
    .kpArticle_listCenter{
      width: 1200px
      margin 0 auto
      display flex
      justify-content space-between
      .kpArticle_nav{
        width: 140px
        .kpArticle_nav_center{
          width: 140px
          background #f2f2f2
          position relative
          &.active{
            position fixed
            top: 0
          }
          .nav_item{
            width: 100%
            height:60px
            display flex
            align-items center
            justify-content center
            font-size: 16px;
            color: #333
            >div{
              min-width: 50%
              font-size: 16px;
              color: #333
            }
            .one{
              margin-right 10px
            }
            .two{
              margin-right 10px
              display none
            }
            &:hover{
              background #63a3fc
              >div{
                font-weight 700
                background #63a3fc
                color: #fff
              }
              .two{
                display block
              }
              .one{
                display none
              }
            }
          }
        }
      }
      .kpArticle_router{
        width: 702px
      }
      .kpArticle_hot{
        width: 331px
        .hebdomad_box{
          .hebdomad{
            font-weight: 700;
            font-size: 20px;
            color: #333
          }
          .disease_card_right{
            margin-top 10px
            width:331px
            .item_list{
              display flex
              flex-wrap wrap
              flex 1
              &:after{
                content: ''
                display block
                width: 100%
                height: 1px
                border-top 1px dashed #e7e7e7
                margin 15px 0
              }
              &:last-child{
               &:after{
                 display none
               }
              }
              .item_GraphicText_list{
                display flex
                .GraphicImg{
                  >img{
                    width: 101px
                    height: 70px
                    margin-right 15px
                  }
                }
                .textTime{
                  height: 70px
                  display flex
                  flex-direction column
                  justify-content space-around
                  >div{
                    color: #5E5E5E
                    font-size 14px
                    text-overflow: -o-ellipsis-lastline;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    line-height 18px
                  }
                  >span{
                    color: #868686
                    font-size 12px
                  }
                }
              }
            }
          }
        }
        .recommend_doctor{
          margin-top 40px
          .recommend{
            font-weight: 700;
            font-size: 20px;
            color: #333
            margin-bottom 15px
          }
          .recommend_list{
            display flex
            flex-wrap wrap
            .item_doctor{
              margin-right 15px
              margin-bottom 25px
              &:nth-child(3n){
                margin-right 0
              }
              .doctor_head{
                >img{
                  width: 100px;
                  height: 70px;
                  display block
                }
              }
              .doctor_name{
                text-align: center
                margin-top 10px
                font-size: 14px;
                color: #333
                max-width:100px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }
          }
        }
      }
    }
  }

</style>





// WEBPACK FOOTER //
// src/views/kpArticle/List.vue